import { render, staticRenderFns } from "./OshaSubView.vue?vue&type=template&id=49b0a706"
import script from "./OshaSubView.vue?vue&type=script&lang=js"
export * from "./OshaSubView.vue?vue&type=script&lang=js"
import style0 from "./OshaSubView.vue?vue&type=style&index=0&id=49b0a706&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports